export default __webpack_public_path__ + "static/media/Goose2Preview.a850c15a.jpeg";